import PropTypes from 'prop-types';
import Moon01Icon from '@untitled-ui/icons-react/build/esm/Moon01';
import SunIcon from '@untitled-ui/icons-react/build/esm/Sun';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

const options = [
  { label: 'Light', value: 'light', icon: SunIcon },
  { label: 'Dark', value: 'dark', icon: Moon01Icon }
];

export const OptionsColorScheme = (props) => {
  const { onChange, value } = props;
  const theme = useTheme();
  const activeIndex = value === 'dark' ? 1 : 0;

  return (
    <Stack spacing={1}>
      <Typography color="text.secondary" variant="overline">
        Color Scheme
      </Typography>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.mode === 'dark'
            ? alpha(theme.palette.common.white, 0.06)
            : alpha(theme.palette.common.black, 0.04),
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2.5,
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          p: '4px',
          position: 'relative'
        }}
      >
        <Box
          aria-hidden
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: theme.palette.mode === 'dark'
              ? '0 2px 10px rgba(0,0,0,0.35)'
              : '0 2px 10px rgba(15,23,42,0.08)',
            height: 'calc(100% - 8px)',
            left: `calc(${activeIndex * 50}% + 4px)`,
            position: 'absolute',
            top: 4,
            transition: 'left 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
            width: 'calc(50% - 4px)'
          }}
        />
        {options.map((option) => {
          const isActive = option.value === value;

          return (
            <Box
              key={option.value}
              component="button"
              onClick={() => onChange?.(option.value)}
              sx={{
                alignItems: 'center',
                bgcolor: 'transparent',
                border: 'none',
                color: isActive ? 'primary.main' : 'text.secondary',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                font: 'inherit',
                gap: 0.5,
                justifyContent: 'center',
                minHeight: 52,
                outline: 'none',
                position: 'relative',
                transition: 'color 0.2s ease',
                zIndex: 1,
                '&:hover': {
                  color: isActive ? 'primary.main' : 'text.primary'
                },
                '&:focus-visible': {
                  borderRadius: 2,
                  boxShadow: (theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.35)}`
                }
              }}
              type="button"
            >
              <SvgIcon sx={{ fontSize: 20 }}>
                <option.icon />
              </SvgIcon>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                {option.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
};

OptionsColorScheme.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf(['light', 'dark'])
};
